(() => {
	angular
		.module('main')
		.controller('ClientProfileController', ClientProfileController);

	ClientProfileController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'messageService',
		'jobDataService',
		'validationService',
		'clientsDataService',
		'notesDataService',
		'emailService',
		'timeService',
		'templateRequestsService',
		'utilsService',
		'jobTypesDataService',
		'workflowDataService',
		'leadDataService',
		'stringModifierService',
		'mailsDataService'
	];

	function ClientProfileController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		messageService,
		jobDataService,
		validationService,
		clientsDataService,
		notesDataService,
		emailService,
		timeService,
		templateRequestsService,
		utilsService,
		jobTypesDataService,
		workflowDataService,
		leadDataService,
		stringModifierService,
		mailsDataService
	) {
		$scope.$on('$viewContentLoaded', () => {
			getContact();

			$scope.isAddNewJobSpinningWheelActive = false;
			$scope.isSaveNotesSpinningWheelActive = false;
			$scope.isCreateClientModalSpinningWheelActive = false;
			$scope.isGetMailsSpinningWheelActive = true;
			$scope.sendEmailLeadId = null;
			$scope.workflowNames = [];
			$scope.primaryContact = null;
			$scope.unsubscribe = new Rx.Subject();
			$scope.customToken = null;
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.notes = '';

		$scope.archivedLead = leadId => {
			leadDataService.archiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_5', 'lead');
					getContact();
				},
				error => {
					const { errorMessage } = error.error;
					if (errorMessage.includes('Lead contains invoices.')) {
						messageService.showToaster('e_4', 'lead');
					} else {
						messageService.showDefaultErrorMessage(error);
					}
				}
			);
		};

		$scope.unArchivedLead = leadId => {
			leadDataService.unarchiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_6', 'lead');
					getContact();
				},
				error => {
					messageService.showDefaultErrorMessage(error);
				}
			);
		};

		function getContact() {
			clientsDataService
				.getClient($routeParams.id)
				.map(data => removeClientMails(data))
				.subscribe(
					data => {
						$scope.data = data;
						$scope.leads = data.leads;
						$scope.jobs = data.jobs;
						$scope.firstName = $scope.data.contact.firstName;
						$scope.lastName = $scope.data.contact.lastName;
						$scope.primaryContact = data.contact;
						$scope.totalInvoiced = data.totalInvoiced;
						$scope.totalPaymentAmountWithCurrency =
							data.totalPaymentAmount.amountWithCurrency;

						$scope.getMails(false);
					},
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		$scope.saveNotes = function() {
			let note2Save;
			$scope.isSaveNotesSpinningWheelActive = true;

			if ($scope.notes) {
				note2Save = $scope.notes;
			} else {
				note2Save =
					$('.in')
						.find('.textarea-quad')
						.find('[id^="taTextElement"]')
						.last()
						.html() || '';
			}

			const isEmpty = note2Save === '<p></p>' || note2Save === '<p><br></p>';

			const notesTmp = !isEmpty ? $rootScope.addMaiStyling(note2Save) : '';

			const data4Save = {
				id: $scope.data.contact.id,
				notes: notesTmp
			};

			notesDataService
				.saveNotes(data4Save, true)
				.finally(() => {
					$scope.isSaveNotesSpinningWheelActive = false;
				})
				.subscribe(
					data => successSaveNotes(data, notesTmp),
					() => toastr.error('Error save note', 'Error')
				);
		};

		function successSaveNotes(data, notesTemp) {
			$scope.$evalAsync();
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
			} else {
				$scope.notes = notesTemp;
				getContact();
				$('#updateModal').modal('hide');
				toastr.success(data.message, 'Success');
			}
		}

		$scope.saveChanges = () => {
			$scope.isCreateClientModalSpinningWheelActive = true;

			if (validationService.isStringEmpty($scope.editClient.firstName)) {
				$scope.isCreateClientModalSpinningWheelActive = false;

				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.editClient.companyName;
				delete $scope.editClient.businessNumber;
			}

			clientsDataService
				.updateClient($scope.editClient)
				.subscribe(
					data => successSaveChanges(data),
					error => errorSaveChanges(error.data),
					() => ($scope.isCreateClientModalSpinningWheelActive = false)
				);
		};

		function successSaveChanges(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				delete $scope.editClient;
				getContact();
				$('#editClient').modal('hide');
				toastr.success(data.message, 'Success');
			}
		}

		function errorSaveChanges(data) {
			if (
				data.errorMessage ===
				'Job contact cannot be changed because invoice has Xero payment'
			) {
				messageService.showToaster('e_10', 'clients');
			} else if (
				data.errorMessage ===
				'Sorry, this customer has been deleted on QuickBooks'
			) {
				messageService.showToaster('e_23', 'qb');
			} else {
				messageService.showToaster('e_6', 'clients');
			}
			$scope.isCreateClientModalSpinningWheelActive = false;
		}

		$scope.showEdit = () => {
			$scope.editClient = angular.copy($scope.data.contact);
			$scope.companyNameChecked =
				!!$scope.editClient.companyName || !!$scope.editClient.businessNumber;
			$('#editClient')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');
					validationService.isModalClosePrevented(input);
				});
		};

		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.map(data => successGetJobTypes(data));
		}

		function successGetJobTypes(data) {
			if ($scope.newJob !== undefined) {
				$scope.newJob.jobTypes = angular.copy(data);
			} else if ($scope.lead !== undefined) {
				$scope.lead.jobTypes = angular.copy(data);
			} else if ($scope.job !== undefined) {
				$scope.job.jobTypes = angular.copy(data);
			}
		}

		function getWorkflowNames() {
			return workflowDataService
				.getWorkflowNames()
				.map(data => successGetWorkflowNames(data));
		}

		function successGetWorkflowNames(data) {
			if (!data) {
				return false;
			}
			if ($scope.newJob !== undefined) {
				$scope.newJob.workflowNames = angular.copy(data);
			} else if ($scope.lead !== undefined) {
				$scope.lead.workflowNames = angular.copy(data);
			} else if ($scope.job !== undefined) {
				$scope.job.workflowNames = angular.copy(data);
			}
		}

		function prepareJobToEdit(job, type) {
			if (type !== 'job' && type !== 'lead') {
				console.log('wrong type was provided');
				return;
			}

			$scope[type].id = job.id;
			$scope.clients = [];

			const {
				workflow,
				startDate,
				startTime,
				finishTime,
				finishDate,
				primaryContact,
				secondaryContact
			} = $scope[type];

			$scope[type].oldWorkflow = workflow;
			if (type === 'job') {
				$scope[type].workflow.name = stringModifierService.addSelectedText(
					$scope[type].workflow.name
				);
				const isWorkflowSaved = $scope[type].workflowNames.find(
					workflow => workflow.id === $scope[type].workflow.id
				);
				if ($scope[type].workflowNames && !isWorkflowSaved) {
					$scope[type].workflowNames.push($scope[type].workflow);
				}
			}

			if (!$scope[type].startDate) {
				$scope[type].hasNoDate = true;
			} else {
				$scope[type].hasNoDate = false;
				$scope[type].startDate = timeService.createDateAsUTC(startDate);
				$scope[type].finishDate = timeService.createDateAsUTC(finishDate);
			}
			if (type === 'lead' && $scope[type].startTime) {
				$scope[type].startTime = timeService.getTimeConvertedTo12(startTime);
				$scope[type].finishTime = timeService.getTimeConvertedTo12(finishTime);
			}
			if (primaryContact) {
				const primaryClientSearchText = jobDataService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope[type].primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = jobDataService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope[type].secondaryContact = $scope.clients[1];
			}

			if (
				$scope[type].startDate &&
				($scope[type].startTime === null || $scope[type].finishTime === null)
			) {
				$scope[type].allday = true;
			}
		}

		function showNewLeadModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newLead';
			$scope.button_disable = false;
			$scope.isCreateJobSpinnningWheelActive = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.$broadcast('showModal', {
				lead: $scope.newJob
			});
			delete $scope.newJob;
		}

		$scope.getMails = function(syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			const subscription = mailsDataService
				.getContactMails($scope.primaryContact.id, syncReply)
				.subscribe(
					data => successGetMails(data.data, syncReply, subscription),
					error => errorGetMails(error, syncReply, subscription)
				);
		};

		function successGetMails(data, syncReply, subscription) {
			const { lastSyncResult, mails } = data;
			$scope.data.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				showCorrectMessage(lastSyncResult, syncReply);
			}

			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}

			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult, syncReply) {
			const status = lastSyncResult.status.toLowerCase();
			const messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok' && syncReply) {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(
					messageType,
					lastSyncResult.messageDetails.title,
					lastSyncResult.messageDetails.message
				);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeClientMails(data) {
			data.mails = [];
			return data;
		}

		$scope.showDeleteModalClient = function(id) {
			$scope.contactForDelete = id;
			$scope.checkForDelete();
		};

		$scope.checkForDelete = function() {
			$scope.button_disable = true;
			clientsDataService
				.checkBeforeDelete($scope.contactForDelete)
				.finally(() => {
					$scope.button_disable = false;
				})
				.subscribe(
					() => $('#deleteModalClient').modal('show'),
					result => {
						if (result.error && result.error.errorCode) {
							$scope.clientDeleteErrorMessage = result.error.errorMessage;
							$('#errorMessageModal').modal('show');
						} else {
							messageService.showDefaultErrorMessage(result);
						}
					}
				);
		};
		$scope.deleteContact = function() {
			$scope.isDeleteContactSpinnningWheelActive = true;
			clientsDataService
				.deleteClient($scope.contactForDelete)
				.finally(() => {
					$scope.isDeleteContactSpinnningWheelActive = false;
				})
				.subscribe(
					data => {
						if (data.errorMessage) {
							$('#deleteModalClient')
								.modal('hide')
								.on('hidden.bs.modal', function() {
									$scope.clientDeleteErrorMessage = data.errorMessage;
									$('#errorMessageModal').modal('show');
									$(this).off('hidden.bs.modal');
								});
						} else {
							messageService.showToaster('s_0', 'clients');

							$('#deleteModalClient').modal('hide');
							$location.path('/clients');
						}
					},
					() => {
						toastr.error('Request to server failed!', 'Error');
					}
				);
		};

		$scope.updateCustomToken = function(token) {
			$scope.customToken = token;
		};

		$scope.openSendMailModal = function(contact, leadId) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;
			$scope.button_disable = true;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
				})
				.subscribe(([emails, mailSignature]) => {
					$scope.mailData2Save = angular.copy(contact);
					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';
					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$routeParams.leadId = leadId;
					$scope.sendEmailLeadId = leadId || null;

					$('#sendContactEmailModal').modal('show');
				});
		};

		$scope.openSendEmailForReply = function() {
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.showDeleteModal = id => {
			$scope.leadForDelete = id;
			$('#deleteModal').modal('show');
		};

		$scope.showDeleteModalJob = id => {
			$scope.jobForDelete = id;
			$('#deleteModalJob').modal('show');
		};

		$scope.deleteLead = () => {
			$scope.deleteDisable = true;

			$http({
				method: 'DELETE',
				url: `/api/user/lead/${$scope.leadForDelete}`
			})
				.then(result => {
					const { message = '', errorMessage = false } = result.data;

					if (errorMessage) {
						toastr.error(errorMessage, 'Error');
					} else {
						if (message.includes('successfully deleted')) {
							messageService.showToaster('s_0', 'jobView');
						} else {
							messageService.showToaster('s_2', 'lead');
						}
						getContact();
						$('#deleteModal').modal('hide');
					}
				})
				.catch(errorDeleteJob)
				.finally(() => {
					$scope.deleteDisable = false;
				});
		};

		$scope.deleteJob = () => {
			$scope.deleteDisable = true;

			$http({
				method: 'GET',
				url: `/protected/rest/jobs/job/delete?id=${$scope.jobForDelete}`
			})
				.then(result => {
					const { message = '', errorMessage = false } = result.data;

					if (errorMessage) {
						toastr.error(errorMessage, 'Error');
					} else {
						if (message.includes('successfully deleted')) {
							messageService.showToaster('s_0', 'jobView');
						} else {
							toastr.success(message, 'Success');
						}
						getContact();
						$('#deleteModalJob').modal('hide');
					}
				})
				.catch(errorDeleteJob)
				.finally(() => {
					$scope.deleteDisable = false;
				});
		};

		function errorDeleteJob({ status, data }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage.includes(
						'This payment cannot be marked as unpaid because it was overpaid in Xero.'
					)
				) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function prepareClientSearchText() {
			$scope.clients = [];
			const primaryClientSearchText = jobDataService.fillClientSearchText(
				$scope.primaryContact
			);
			$scope.clients[0] = primaryClientSearchText;
			$scope.newJob.primaryContact = $scope.clients[0];
		}

		$scope.showEditJobModal = function(job) {
			$scope.job = JSON.parse(JSON.stringify(job));
			$scope.isCreateLeadSpinningWheelActive = true;
			$scope.button_disable = true;

			Rx.Observable.zip(getJobTypes(), getWorkflowNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isCreateLeadSpinningWheelActive = false;
					$scope.button_disable = false;
				})
				.subscribe(() => {
					prepareJobToEdit($scope.job, 'job');
					$('#newJob').modal('show');
					$scope.$broadcast('showModalJob', $scope.job);
					delete $scope.job;
				});
		};

		$scope.showAddNewJobModal = function() {
			$scope.button_disable = true;
			$scope.isAddNewJobSpinningWheelActive = true;
			$scope.newJob = {};

			prepareClientSearchText();

			Rx.Observable.zip(getJobTypes(), getWorkflowNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isAddNewJobSpinningWheelActive = false;
					$scope.button_disable = false;
				})
				.subscribe(() => {
					showNewJobModal();
				});
		};

		function showNewJobModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newJob';
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
			delete $scope.newJob;
		}

		$scope.changeClientSubscription = function(contact) {
			clientsDataService.changeClientSubscription(contact).subscribe(
				result => {
					if (contact.status === 'SUBSCRIBED') {
						messageService.showToaster('s_1', 'subscribed');
					} else {
						messageService.showToaster('s_0', 'subscribed');
					}
					getContact();
				},
				error => messageService.showDefaultErrorMessage(error)
			);
		};

		$scope.showAddNewLeadModal = event => {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.isAddNewLeadSpinningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.clients = [];

			prepareClientSearchText();

			Rx.Observable.zip(getJobTypes(), getWorkflowNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isDisabled = true;
					$scope.button_disable = false;
					$scope.isAddNewLeadSpinningWheelActive = false;
				})
				.subscribe(() => {
					showNewLeadModal(event);
				});
		};

		$scope.showEditLeadModal = function(lead) {
			$scope.lead = angular.copy(lead);
			$scope.button_disable = true;

			Rx.Observable.zip(getJobTypes(), getWorkflowNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
				})
				.subscribe(() => {
					prepareJobToEdit($scope.lead, 'lead');
					$('#newLead').modal('show');
					$scope.$broadcast('showModal', {
						lead: $scope.lead,
						jobId: $scope.lead.jobId
					});
					delete $scope.lead;
				});
		};

		$rootScope.updateClientView = function() {
			getContact();
		};

		$scope.goToJob = function(id) {
			$location.path(`jobs/view/${id}`);
		};

		$scope.openEditNotesModal = function() {
			try {
				const isContact = $scope.data && $scope.data.contact;
				$scope.notes = isContact ? $scope.data.contact.notes || '' : '';
			} catch (e) {
				console.log('catch open', e);
			}
			$('#updateModal').modal('show');
		};

		$scope.showSaveOptInModal = function() {
			$('#saveOptinConsentModal').modal('show');
		};

		$scope.disableDragDrop = function() {
			return true;
		};

		$scope.setClientMail = (clientMailData, jobMailData) => {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		$scope.retrySendMail = function() {
			getContact();
			emailService.callLastEmailFn();
		};

		$scope.addNew = () => {
			$('#addNewModal').modal('show');
		};

		$scope.onDeleteConsent = function(id) {
			clientsDataService
				.deleteConsent($scope.primaryContact.id, id)
				.subscribe(
					() => getContact(),
					error => messageService.showDefaultErrorMessage(error)
				);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/clientProfileController.js